import Button from "components/Inputs/Button";
import { CollectContext } from "pages/Collect";
import { FC, useContext, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { IProps } from "./core/modalCollectDisclaimer.types";
import { IConfigurationState } from "redux/configuration/configuration.interface";
import { AppThunkDispatch } from "redux/configuration/configuration.types";
import { setRewardValidation } from "redux/game/game.actions";
import { RewardValidationFailure } from "redux/game/game.interface";

const ModalCollectDisclaimer: FC<IProps> = ({
  hideModal,
  hideModalCollectInstructions,
}) => {
  const { t } = useTranslation("modals");
  const { t: tHome } = useTranslation("home");
  const collectContext = useContext(CollectContext);
  const { rewardId, companyId } = { ...collectContext };
  const dispatch: AppThunkDispatch = useDispatch();
  const { reward } = useSelector((state: IConfigurationState) => state);
  const toWhom = reward?.tw;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationFailure, setValidationFailure] =
    useState<RewardValidationFailure | null>(null);
  const [claimAttempt, setClaimAttempt] = useState(0);
  const lastSubmittedClaimAttempt = useRef<number | null>(null);

  const handleClaim = async () => {
    if (
      !rewardId ||
      !companyId ||
      lastSubmittedClaimAttempt.current === claimAttempt
    ) {
      return;
    }

    lastSubmittedClaimAttempt.current = claimAttempt;
    setIsSubmitting(true);
    setValidationFailure(null);

    const result = await dispatch(setRewardValidation(companyId, rewardId));

    if (result.success === false) {
      setValidationFailure(result.error);
      setIsSubmitting(false);
      setClaimAttempt((currentAttempt) => currentAttempt + 1);
      return;
    }

    hideModal();
    setTimeout(() => {
      hideModalCollectInstructions();
    }, 400);
  };

  const errorKey =
    validationFailure === RewardValidationFailure.TEMPORARY
      ? "collect.disclaimer.temporaryError"
      : validationFailure
      ? `collect.${validationFailure}Collect.subtitle`
      : null;
  const errorTitleKey =
    validationFailure === RewardValidationFailure.TEMPORARY
      ? "collect.disclaimer.temporaryErrorTitle"
      : validationFailure
      ? `collect.${validationFailure}Collect.title`
      : null;

  return (
    <div className="modal__content">
      <div className="modal__img">
        <img
          src="/static/images/modals/exclamation-mark.png"
          alt="exclamation mark emoji"
        />
      </div>
      <h2 className="modal__title">
        {t(errorTitleKey || "collect.disclaimer.title")}
        {!validationFailure && <span className="c-primary">{toWhom}</span>}
      </h2>
      {errorKey ? (
        <p role="alert" className="mb-2">
          {t(errorKey)}
        </p>
      ) : (
        <p>
          <Trans
            ns="modals"
            i18nKey="collect.disclaimer.subtitle"
            components={[<span className="c-primary fw-700"></span>]}
          />
        </p>
      )}
      {(!validationFailure ||
        validationFailure === RewardValidationFailure.TEMPORARY) && (
        <Button
          onClick={handleClaim}
          text={
            validationFailure ? tHome("retryCTA") : t("collect.disclaimer.CTA")
          }
          className="modal__btn"
          loading={isSubmitting}
        />
      )}
    </div>
  );
};

export default ModalCollectDisclaimer;
